import { render, staticRenderFns } from "./examredroom.vue?vue&type=template&id=12d1d82f&scoped=true&"
import script from "./examredroom.vue?vue&type=script&lang=js&"
export * from "./examredroom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d1d82f",
  null
  
)

export default component.exports